import { motion } from "framer-motion";
import RegisterForm from "./register-form";
import type { Route } from "../../+types/layout";
import { useModal } from "@/hooks/modal-hooks";
import { ssoApi } from "@/redux/sso/sso-api";
import React from "react";
import VerifyAccountForm from "../verify-account/form";

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Nettpay" },
    { name: "description", content: "Nettpay | Create A New Nettpay Account" },
  ];
}

const Register = () => {
  const otpVerificationPage = useModal();
  const [submittedData, setSubmittedData] =
    React.useState<SSOCreateAccountPayload | null>(null);

  const [createAccount, { isLoading, isSuccess, isError, error }] =
    ssoApi.useCreateSSOAccountMutation();

  const onSubmit = async (data: SSOCreateAccountPayload) => {
    setSubmittedData(data);
    await createAccount(data).unwrap();
  };

  React.useEffect(() => {
    if (isSuccess) {
      otpVerificationPage.toggle(true);
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (!otpVerificationPage.open) setSubmittedData(null);
  }, [otpVerificationPage.open]);

  return (
    <motion.div
      className="flex-1 p-8 md:p-12 bg-white backdrop-blur-lg h-fit rounded-xl"
      style={{ boxShadow: "0px 4px 10px 0px #3182CE" }}
      initial={{ opacity: 0, x: 200 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="text-2xl font-bold mb-12 text-gray-800">
        {otpVerificationPage.open && isSuccess ? "Verify" : "Create"} your
        Nettpay Account
      </h2>

      {otpVerificationPage.open && submittedData ? (
        <VerifyAccountForm
          ctaText="Verify Account"
          nextPage="/auth/login"
          verificationType="verify_account"
          password={submittedData.password}
          username={submittedData.email as string}
          toggleVisiblity={() => otpVerificationPage.toggle(false)}
        />
      ) : (
        <RegisterForm
          handleSubmit={onSubmit}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      )}
    </motion.div>
  );
};

export default Register;
